<template>
  <div class="h-100 d-block p-2 d-flex align-items-center">
    <b-table-simple
      striped
      hover
      responsive
      bordered
      small
    >
      <b-thead>
        <b-tr>
          <b-th>Marka</b-th>
          <b-th class="text-center">
            Valör
          </b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <b-tr
          v-for="(item,index) in dataList"
          :key="index"
        >
          <b-td>
            <div class="font-weight-bold">
              {{ item.title }}
            </div>
          </b-td>
          <b-td class="text-center">
            <div class="font-weight-bold">
              {{ item.value_date }}
            </div>
          </b-td>
        </b-tr>
      </b-tbody>
    </b-table-simple>
  </div>
</template>
<script>
import {
  BTableSimple, BThead, BTr, BTh, BTbody, BTd,
} from 'bootstrap-vue'

export default {
  name: 'TableStocks',
  components: {
    BTableSimple,
    BThead,
    BTr,
    BTh,
    BTbody,
    BTd,
  },
  props: {
    dataList: {
      type: Array,
      required: true,
    },
  },
}
</script>
